import React, { useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import AssignUser from "./assignUser";
// import AllUsers from "./allUsers"; // commented

const MainPage = () => {
  const [selectedOption, setSelectedOption] = useState("new");

  return (
    <div style={{ padding: "0px" }}>
      <FormControl component="fieldset">
        <RadioGroup
          row
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          {/* <FormControlLabel
            value="new"
            control={<Radio size="small" />}
            label="New"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "13px" } }}
          /> */}

          {/*
          <FormControlLabel
            value="existing"
            control={<Radio size="small" />}
            label="Existing"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "13px" } }}
          />
          */}
        </RadioGroup>
      </FormControl>

      <div style={{ marginTop: "20px" }}>
        <AssignUser />

        {/*
        {selectedOption === "new" ? <AssignUser /> : <AllUsers />}
        */}
      </div>
    </div>
  );
};

export default MainPage;
